
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Handle legacy homepage redirects
    const legacyRoutes = ['/homepage', '/home'];
    
    if (legacyRoutes.includes(location.pathname)) {
      // 301 redirect to root
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};
